<template>
    <div id="whats-new">
        <svg @click="close" class="btn-close" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24"
             width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <span class="sidebar-title mb-7">What’s new in version 2.2?</span>

        <VueSlickCarousel v-bind="settings">
            <div class="whats-new-item">
                <iframe class="whats-new-item--video" width="560" height="315" src="https://www.youtube.com/embed/e7BKXaV3WO0?si=IOYJz4_lH5lX90p8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div class="whats-new-item--description">
                    <span class="label">Improved AI Color Match</span>
                    <p class="d-block" style="text-align: left; line-height: 1.2">fylm.ai 2.2. introduces improved AI
                                                                                  Colour Match that's smarter and produces significantly better results compared to the previous
                                                                                  version. AI Color Match uses completely new AI colour matching models that have been trained
                                                                                  from the ground up to better understand the context of different colour grades.</p>

                    <button type="button" class="button button--primary mt-3">
                        <a href="https://fylm.ai/fylm-ai-22-update/" target="_blank"
                           class="whats-new-item--external-link">
                            <span class="font-weight-bold">Learn More</span>
                        </a>
                    </button>
                </div>
            </div>

            <div class="whats-new-item">
                <iframe class="whats-new-item--video" width="560" height="315" src="https://www.youtube.com/embed/sDSgwVGm8BM?si=gEI7I5uoCzLGZGtL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div class="whats-new-item--description">
                    <span class="label">Improved AI Auto Correct</span>
                    <p class="d-block" style="text-align: left; line-height: 1.2">fylm.ai 2.2 introduces improved AI
                                                                                  Auto Correct tool which automatically color balances your images and prepares them for further
                                                                                  creative color grading. AI Auto Correct uses completely new AI colour correction models that
                                                                                  have been trained from the ground up to better understand the context of different colour
                                                                                  grades.</p>

                    <button type="button" class="button button--primary mt-3">
                        <a href="https://fylm.ai/fylm-ai-22-update/" target="_blank"
                           class="whats-new-item--external-link">
                            <span class="font-weight-bold">Learn More</span>
                        </a>
                    </button>
                </div>
            </div>

            <div class="whats-new-item">
                <iframe class="whats-new-item--video" width="560" height="315" src="https://www.youtube.com/embed/vzi2UN-0vlA?si=yBSq5-U4nGh3pmsS" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div class="whats-new-item--description">
                    <span class="label">Tetrahedral Interpolation</span>
                    <p class="d-block" style="text-align: left; line-height: 1.2">fylm.ai 2.2 introduces a completely
                                                                                  new Tetrahedral Interpolation tool that allows you to create complex and advanced colour grades
                                                                                  effortlessly. Tetrahedral interpolation allows for precise hue, saturation and lightness
                                                                                  controls in a non-destructive way while allowing you to work in either subtractive or additive
                                                                                  modes.</p>

                    <button type="button" class="button button--primary mt-3">
                        <a href="https://fylm.ai/fylm-ai-22-update/" target="_blank"
                           class="whats-new-item--external-link">
                            <span class="font-weight-bold">Learn More</span>
                        </a>
                    </button>
                </div>
            </div>

            <div class="whats-new-item">
                <iframe class="whats-new-item--video" width="560" height="315" src="https://www.youtube.com/embed/gqO8bDMOvR8?si=3FldhsUlTU5jm5DX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div class="whats-new-item--description">
                    <span class="label">Dedicated Skin Tone Editor tool</span>
                    <p class="d-block" style="text-align: left; line-height: 1.2">fylm.ai 2.2 features a dedicated skin
                                                                                  tone editor tool which allows you to easily control the hue, saturation and luminance of skin
                                                                                  tones in your images. The tool's range is limited to skin tones for more precise control under
                                                                                  various conditions.</p>

                    <button type="button" class="button button--primary mt-3">
                        <a href="https://fylm.ai/fylm-ai-22-update/" target="_blank"
                           class="whats-new-item--external-link">
                            <span class="font-weight-bold">Learn More</span>
                        </a>
                    </button>
                </div>
            </div>

            <div class="whats-new-item">
                <a href="https://deq92n7dtkee9.cloudfront.net/wp-content/uploads/2024/11/improved-raw-handling-22-update.jpg" target="_blank" class="whats-new-item--image-container">
                    <img src="https://deq92n7dtkee9.cloudfront.net/wp-content/uploads/2024/11/improved-raw-handling-22-update.jpg" class="whats-new-item--image">
                </a>

                <div class="whats-new-item--description">
                    <span class="label">Improved Raw files handling</span>
                    <p class="d-block" style="text-align: left; line-height: 1.2">fylm.ai 2.2 introduces enhanced
                                                                                  handling of large raw files and a 20% speed boost for faster opening times, making your workflow
                                                                                  more efficient than ever.</p>

                    <button type="button" class="button button--primary mt-3">
                        <a href="https://fylm.ai/fylm-ai-22-update/" target="_blank"
                           class="whats-new-item--external-link">
                            <span class="font-weight-bold">Learn More</span>
                        </a>
                    </button>
                </div>
            </div>

            <div class="whats-new-item">
                <a href="https://deq92n7dtkee9.cloudfront.net/wp-content/uploads/2024/11/add-to-downloads-22-update.jpg" target="_blank" class="whats-new-item--image-container">
                    <img src="https://deq92n7dtkee9.cloudfront.net/wp-content/uploads/2024/11/add-to-downloads-22-update.jpg" class="whats-new-item--image">
                </a>

                <div class="whats-new-item--description">
                    <span class="label">Guest Downloads (Pro plan only)</span>
                    <p class="d-block" style="text-align: left; line-height: 1.2">We're excited to announce Guest
                                                                                  Downloads that allow Guests to download high-resolution, colour-graded images, expanding access
                                                                                  beyond Collaborators and making it easier for the free-to-add Guests to obtain the files they
                                                                                  need.</p>

                    <button type="button" class="button button--primary mt-3">
                        <a href="https://fylm.ai/fylm-ai-22-update/" target="_blank"
                           class="whats-new-item--external-link">
                            <span class="font-weight-bold">Learn More</span>
                        </a>
                    </button>
                </div>
            </div>

            <template #prevArrow>
                <v-icon size="36" color="white" class="material-icons">chevron_left</v-icon>
            </template>

            <template #nextArrow>
                <v-icon size="36" color="white" class="material-icons">chevron_right</v-icon>
            </template>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    components: {VueSlickCarousel},

    data() {
        return {
            settings: {
                slidesToShow: 1,
                arrows: true,
                dots: true,
                infinite: false,
                adaptiveHeight: true
            },
        }
    },

    mounted() {
        this.$root.$refs.whatsNewSlider = this.$refs['whats-new-slider'];
    },

    methods: {
        close() {
            localStorage.setItem('whats-new-2.2', 1);
            this.$store.dispatch('UI/toggleWhatsNewDrawer', false);
        },
    }
};
</script>

<style lang="scss" scoped>
#whats-new {
    padding: 80px 20px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .btn-close {
        fill: var(--font-default-color);
        cursor: pointer;
        position: absolute;
        top: 30px;
        right: 20px;
    }

    .sidebar-title {
        font-size: 2rem !important;
        line-height: 1;

        background-image: linear-gradient(90deg, hsla(197, 100%, 63%, 1) 0%, hsla(294, 100%, 55%, 1) 100%);
        -webkit-background-clip: text;
        display: inline-block;
        -webkit-text-fill-color: transparent;
    }

    ::v-deep .slick-slider {
        //flex: 1;
        height: 100%;
    }

    ::v-deep .slick-prev.slick-disabled,
    ::v-deep .slick-next.slick-disabled {
        opacity: 0.25;
    }

    ::v-deep .slick-prev {
        transform: none;
        top: initial;
        left: 0;
        bottom: 0;
        position: absolute;

        &:before {
            display: none;
        }
    }

    ::v-deep .slick-next {
        transform: none;
        top: initial;
        right: 0;
        bottom: 0;
        position: absolute;

        &:before {
            display: none;
        }
    }

    ::v-deep .slick-dots {
        bottom: 0;
        padding: 0 !important;
        width: auto;
        left: 50%;
        transform: translateX(-50%);

        li {
            margin: 0;
        }

        button::before {
            color: white;
            opacity: 1;
        }

        .slick-active button::before {
            color: var(--color-accent);
        }
    }

    .whats-new-item {
        display: flex !important;
        flex-direction: column;
        gap: 25px;
        height: 100%;

        &--description {
            color: var(--font-default-color);

            .label {
                font-size: 1rem;
                line-height: 2;
                font-weight: bold;
                color: white;
            }

            p {
                line-height: 1.2;
            }
        }

        &--video {
            width: auto !important;
            aspect-ratio: 16/9;
            height: auto !important;
            border-radius: 10px;
        }

        &--image-container {
            display: flex;
            flex-direction: column;
            //gap: 40px;
        }

        &--image {
            height: 220px;
            object-fit: cover;
            border-radius: 10px;
            //padding: 20px;
        }

        &--title {
            font-size: 1.5rem;
            line-height: 1.2;
            font-weight: bold;
            color: white;
        }

        &--external-link {
            color: white;
        }
    }
}
</style>
